import { isStandaloneDisplay } from 'utils/platform';

// Leave the app for a neutral page. Poisons this tab first (sessionStorage `redirect` + a
// replaceState entry) so the back-trap can't bounce back in.
//
// tryClose: on a panic exit from an installed PWA (e.g. a disguise shortcut), close the window
// outright — the strongest outcome, the app disappears entirely. In a PWA the Back-trap is skipped
// (see utils/backTrap), so the history is a single entry and this window is script-closable —
// window.close() closes it. If for any reason it is refused, the window survives and we fall back to
// the neutral page a moment later. Only attempted in a PWA; a browser tab goes straight to the page.
export const redirectToSafePage = ({ tryClose = false } = {}) => {
  sessionStorage.setItem('redirect', 1);
  window.history.replaceState({ redirected: true }, '');
  const leave = () => window.location.replace('https://www.google.com/');
  if (tryClose && isStandaloneDisplay()) {
    window.close();
    setTimeout(leave, 300);
  } else {
    leave();
  }
};
